
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/tools/ai-text-generator",
      function () {
        return require("private-next-pages/app/tools/ai-text-generator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/tools/ai-text-generator"])
      });
    }
  